import {UI} from "../../../../../stem-core/src/ui/UIBase";

import {ChooseCardComponent} from "./components/ChooseCardComponent";
import {PayWithAddedCardComponent} from "./components/PayWithAddedCardComponent";
import {PaymentMethodAcceptOrChange} from "./components/PaymentMethodAcceptOrChange.jsx";

import {BasePanelPage} from "../../../PanelPage";
import {Messages} from "../../../../Messages";
import {PaymentMethodStore} from "../../../../../client/state/PaymentMethodStore";
import {MerchantButton} from "../../../../common/MerchantButton";
import {wrapInSpinner} from "../../../../../core/ui/LoadingSpinner.jsx";
import {iFrameUserDataService} from "../../../../services/IFrameUserDataService";
import {CARD_SECTION_STATE} from "../../../flows/PaymentMethodController.js";
import {iFrameMerchantService} from "../../../../services/IframeMerchantService";
import {Router} from "../../../../../stem-core/src/ui/Router";
import {iFrameState} from "../../../../services/IFrameState";
import {PANEL_TYPE} from "../../../../../blink-sdk/Constants";
import {Controller} from "../../../flows/Controller.js";
import {autoredraw} from "../../../../../stem-core/src/decorators/AutoRedraw.js";


// TODO @mustfix WTF
const CARD_SECTION_MAP = {
    [CARD_SECTION_STATE.chooseCard]: ChooseCardComponent,
    [CARD_SECTION_STATE.payWithAddedCard]: PayWithAddedCardComponent,
    [CARD_SECTION_STATE.usingCard]: PaymentMethodAcceptOrChange,
    [CARD_SECTION_STATE.addCard]: PayWithAddedCardComponent,
};

@autoredraw(PaymentMethodStore)
export class PaymentMethodPanel extends BasePanelPage {
    getCardSectionState() {
        if ((!Controller.paymentMethod.initialPaymentMethod && !iFrameUserDataService.getExtraPaymentMethodCount())
            || iFrameMerchantService.isCDSPaymentMethod()) {
            Controller.paymentMethod.cardSectionState = CARD_SECTION_STATE.payWithAddedCard;
        }
        return Controller.paymentMethod.cardSectionState;
    }

    render() {
        const {styleSheet} = this;

        Controller.paymentMethod.autoselectPaymentMethod();

        // TODO @cleanup dumb ass
        const CardSectionClass = CARD_SECTION_MAP[this.getCardSectionState()];
        const onAddCard = () => {
            Controller.paymentMethod.cardSectionState = CARD_SECTION_STATE.addCard;
            Router.updateURL();
        };

        return [
            <div className={styleSheet.title}>{Messages.paymentDetails}</div>,
            <CardSectionClass
                ref="cardComponent"
                paymentMethod={Controller.paymentMethod.selectedPaymentMethod}
                className={this.styleSheet.cardComponent}
                hideActiveCard={true}
                onChange={() => this.redraw()}
                onAddCard={onAddCard}
                entry={Controller.paymentMethod.entry}
            />,
            this.renderButtonSection(),
        ];
    }

    isButtonDisabled() {
        return !(this.cardComponent?.isValid());
    }

    renderButtonSection() {
        const {styleSheet} = this;

        const cancelAddCard = () => {
            Controller.paymentMethod.cardSectionState = CARD_SECTION_STATE.chooseCard;
            Router.updateURL();
        };
        const giftSubscriptionMessage = iFrameState.panelType === PANEL_TYPE.giftSubscription ?
            <div>{Messages.giftPaymentMethodDescription}</div> : "";

        if (this.getCardSectionState() === CARD_SECTION_STATE.chooseCard ||
            this.getCardSectionState() === CARD_SECTION_STATE.payWithAddedCard) {
            return [
                giftSubscriptionMessage, // WTF, what?
                <MerchantButton
                    ref="button"
                    className={styleSheet.actionButton}
                    disabled={this.isButtonDisabled()}
                    label={this.getCardSectionState() === CARD_SECTION_STATE.payWithAddedCard ?
                        Controller.paymentMethod.getPayWithAddedCardButtonLabel() :
                        Controller.paymentMethod.getChooseCardButtonLabel()}
                    onClick={() => this.continueWithChosenCard()}
                />,

                <div className={styleSheet.backButton} onClick={() => Router.back()}>
                    {Messages.back}
                </div>
            ];
        }

        return [
            giftSubscriptionMessage,
            <MerchantButton
                ref="button"
                className={styleSheet.actionButton}
                disabled={this.isButtonDisabled()}
                label={Messages.continue}
                onClick={() => this.addCard()}
            />,
            <div onClick={cancelAddCard} className={styleSheet.backButton}>
                {Messages.cancel}
            </div>
        ];
    }

    @wrapInSpinner
    async continueWithChosenCard() {
        Controller.paymentMethod.selectedPaymentMethod = await this.cardComponent.getPaymentMethod(Controller.paymentMethod.getScope());
        Controller.paymentMethod.onSelectSuccess();
    }

    @wrapInSpinner
    async addCard() {
        Controller.paymentMethod.selectedPaymentMethod = await this.cardComponent.getPaymentMethod(Controller.paymentMethod.getScope());
        Controller.paymentMethod.cardSectionState = CARD_SECTION_STATE.chooseCard;
        Router.updateURL();
    }

    onMount() {
        super.onMount();
        this.redraw(); // TODO @input needed for the button to not be disabled
    }
}
